import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
import loadConfig from "@Web3WalletConfig/config";
export default {
  name: "gift",
  computed: {
    ...walletVuex.mapState(["isMobile", "theme", 'setting'])
  },
  data() {
    return {
      loadConfig,
      isLock: false,
      list: [],
      popEventsShow: false,
      popOpenEventShow: false,
      modifyData: {
        "icon": ""
      },
      isLoading: false,
      selectTab: 1,
      total: 0,
      condition: {
        page: 1,
        limit: 15
      },
      multiplierInfo: [{
        "multiple": 1,
        "stars": 0
      }, {
        "multiple": 2,
        "stars": 50
      }, {
        "multiple": 5,
        "stars": 100
      }, {
        "multiple": 10,
        "stars": 200
      }, {
        "multiple": 20,
        "stars": 300
      }, {
        "multiple": 50,
        "stars": 600
      }, {
        "multiple": 100,
        "stars": 999
      }],
      partnerInfo: {
        name: "Partner Event",
        icon: "",
        buttonTitle: "",
        buttonUrl: "",
        title: "",
        description: ""
      },
      fixedTime: null
    };
  },
  methods: {
    async getData() {
      this.isLoading = true;
      let rs = await this.$http.post("/events/list", {
        status: this.selectTab,
        ...this.condition
      });
      this.isLoading = false;
      if (rs.code == 0) {
        this.list = rs.data.items;
        this.total = rs.data.total;
      }
    },
    async onCreate() {
      console.log(JSON.stringify(this.partnerInfo));
      this.modifyData = {
        "icon": "",
        "background": "",
        "type": 'BASIC',
        'status': "1",
        "multiplierInfo": this.multiplierInfo,
        "default_multiple_index": '0',
        "partnerInfo": this.partnerInfo
      };
      this.popEventsShow = true;
    },
    async onModify(item) {
      this.modifyData = item;
      this.popEventsShow = true;
    },
    async openEevents(item) {
      this.modifyData = item;
      this.modifyData.notify = 1;
      this.popOpenEventShow = true;
    },
    cutStr(str) {
      if (str) return str.replace("T", " ").replace(".000Z", "");
    },
    onRefresh() {
      this.getData();
    },
    onPageChange(e) {
      this.condition.page = e;
      this.getData();
    },
    onPageSizeChange(e) {
      this.condition.limit = e;
      this.getData();
    },
    resetFixed() {
      clearTimeout(this.fixedTime);
      let list = this.$refs.fixed;
      if (list) {
        list.forEach((item, index) => {
          const rect = item.parentElement.getBoundingClientRect();
          // 计算父级元素距离页面顶部的距离
          const offsetTop = rect.top + window.scrollY;
          item.style.top = offsetTop + "px";
        });
      }
      this.fixedTime = setTimeout(() => {
        this.resetFixed();
      }, 1);
    }
  },
  mounted() {
    this.getData();
    this.resetFixed();
  },
  beforeDestroy() {
    clearTimeout(this.fixedTime);
  }
};